import { Grid, TextField, FormHelperText } from '@material-ui/core/';
import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldError, useFormContext } from 'react-hook-form';
import { getValidator, UserRole } from '../../Constants/constants';
import { DictUserRole } from '../../API/Interfaces/IUserDtos';
import SelectLocation, { ISelectLocationProps } from '../../Layout/Components/SelectLocation';
import { isInRole } from '../../Utils/roleChecker';
import { UserContext } from '../../Context/UserContext';

interface IGraphicFormProps {
	disabled?: boolean;
}

export default function GraphicForm(props: IGraphicFormProps) {
	const { t } = useTranslation();
	const { errors, register, setValue } = useFormContext();
	const userContext = useContext(UserContext);

	const formLabels = {
		name: t('common.table.nameHeader'),
	};

	const formValidators = {
		name: getValidator(t, 40, null, true),
	};

	const selectLocationProps: ISelectLocationProps = {
		userFormType: DictUserRole.CorporationAdmin,
	};

	useEffect(() => {
		if (!(isInRole(userContext.userRoles, UserRole.DealerAdmin) || isInRole(userContext.userRoles, UserRole.SuperAdmin))) {
			setValue('corporationId', userContext.userWorkplaceId);
		}
	});

	return (
		<>
			<input name='id' ref={register()} hidden={true} />
			<input name='pictureFile' type='file' ref={register()} hidden />
			<input name='dictType' type='number' ref={register()} hidden />

			<Grid item xs={12}>
				<TextField
					error={errors.name !== undefined}
					helperText={(errors.name as FieldError)?.message}
					label={formLabels.name}
					name='name'
					inputRef={register(formValidators.name)}
					fullWidth
					disabled={props.disabled}
				/>
			</Grid>

			{isInRole(userContext.userRoles, UserRole.DealerAdmin) || isInRole(userContext.userRoles, UserRole.SuperAdmin) ? (
				<>
					<SelectLocation {...selectLocationProps} />
					<Grid item xs={6} />
				</>
			) : (
				<input hidden name='corporationId' ref={register()}></input>
			)}

			<div style={{ position: 'absolute', bottom: 0, left: 1 }}>
				{errors.image !== undefined && (
					<FormHelperText error={errors.image !== undefined}>{(errors.image as FieldError)?.message}</FormHelperText>
				)}
			</div>
		</>
	);
}
